import * as cookies from 'js-cookie'

export default ({ app }, inject) => {
    // check if user agent is Safari
    const userAgent = window.navigator.userAgent
    const hasSafari = userAgent.includes('Safari')
    const hasChrome = userAgent.includes('Chrome')
    const isSafari = hasSafari && !hasChrome

    function set(key, data, options) {
        // if browser isn't safari set the samesite attribute to options
        if (!isSafari) options.sameSite = 'lax'
        cookies.set(key, data, options)
    }

    function get(key) {
        // console.log(cookies.get(key))
        return cookies.get(key)
    }

    function remove(key) {
        cookies.remove(key)
    }

    function getJSON(key) {
        return cookies.getJSON(key)
    }

    inject('clientCookies', {
        set,
        get,
        remove,
        getJSON,
    })
}
